import { useEffect } from 'react';
import { cache } from 'src/redux/store';
import { addMemberState, useIsSelecting } from 'src/services/app';
import { useObservableBlock, useObservableStore } from 'src/services/rxjs-redux/hook';
import { useGetSyncService } from 'src/services/sync';
import { getDynamicPageId, useGetPageId } from 'src/utils/getPageId';
import { useIsInRight } from 'src/utils/right-utils';
import { useSendPresenceData } from '../user/use-send-presence-data';

/**
 * 监听和发送团队成员状态
 */
export const useSendMembersState = () => {
  const sendPresenceData = useSendPresenceData();
  const isSelecting = useIsSelecting();
  // TODO 可以优化，只监听长度。在 RX 内部优化
  const selectedBlocks = useObservableStore(
    ({ ui }) => (isSelecting ? null : ui.selectedBlocks),
    [isSelecting],
    { obsSelectBlocks: [{ all: true }], waitMode: 'debounce', wait: 200 }
  );

  useEffect(() => {
    if (selectedBlocks && selectedBlocks.length > 0) {
      const blockId = cache.ui.selectedBlocks[0]?.blockId;
      blockId && sendPresenceData(getDynamicPageId(), blockId);
    }
  }, [selectedBlocks, sendPresenceData]);
};

export const useListenMembersStateInPage = () => {
  const pageId = useGetPageId();
  const sendPresenceData = useSendPresenceData();
  const sync = useGetSyncService();
  const isInRight = useIsInRight();
  const hasBlock = useObservableBlock(pageId, (block) => !!block);

  useEffect(() => {
    if (!pageId) return;
    const unsubscribe = sync.subscribePresencePages(pageId, (packet) => {
      // TODO: 处理 recover 通知---by yu xiang
      if (packet?.table === 'presence') {
        const reportPageId = packet.channel.substring('/presences/'.length, packet.channel.length);

        if (packet.data.present) {
          addMemberState({
            userId: packet.data.userId,
            pageId: reportPageId,
            activityTime: packet.data.activityTime,
            blockId: packet.data.blockId,
            present: true,
          });
        } else {
          addMemberState({
            userId: packet.data.userId,
            present: false,
            pageId: reportPageId,
            activityTime: packet.data.activityTime || Date.now(),
            blockId: '',
          });
        }
      }
    });
    const visibilityChange = () => {
      if (!hasBlock) return;
      if (document.visibilityState === 'hidden') {
        sendPresenceData(pageId, '', false);
      } else {
        sendPresenceData(pageId, '', true);
      }
    };
    document.addEventListener('visibilitychange', visibilityChange);

    return () => {
      unsubscribe?.();
      document.removeEventListener('visibilitychange', visibilityChange);
    };
  }, [pageId, sync, sendPresenceData, hasBlock]);

  useEffect(() => {
    if (!pageId) return;
    const page = cache.blocks[pageId];
    if (!page) return;
    sendPresenceData(pageId, ''); // 表示当前在线但没编辑block
    return () => {
      if (isInRight) {
        // 如果是右侧元素就需要发个回到左侧主页面的通知
        const mainPageId = getDynamicPageId('left');
        sendPresenceData(mainPageId, pageId);
      } else {
        sendPresenceData(pageId, undefined, false);
      }
    };
  }, [isInRight, pageId, sendPresenceData]);
};
